import { useState, useCallback } from 'react';
import DOMPurify from 'dompurify';


function encodeHtmlToBase64(htmlContent) {
  const encoder = new TextEncoder();
  const encoded = encoder.encode(htmlContent);
  const blob = new Blob([encoded], { type: 'text/plain; charset=utf-8' });

  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onloadend = () => {
      const base64data = reader.result.split(',')[1]; // Removes the Data URL part
      resolve(base64data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export const decodeBase64ToHtml = (base64data) => {
  // Regular expression to check if the string is Base64 encoded
  const base64Regex = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;

  // Check if the input is a valid Base64 encoded string

  if (!base64Regex.test(base64data)) {
    // console.log("Input is not a valid Base64 encoded string. Returning original input.");
    return base64data; // Return the original string if it's not valid Base64
  }

  try {
    // Decode the Base64 string to a binary string
    const binaryString = atob(base64data);

    // Convert the binary string to a character string using decodeURIComponent and escape
    const decodedHtml = decodeURIComponent(Array.from(binaryString).map(c => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return decodedHtml;
  } catch (error) {
    console.error("Failed to decode Base64 string:", error);
    return null;
  }
}



export const useSanitizeAndEncode = () => {
  const [encodedHtml, setEncodedHtml] = useState('');

  const sanitizeAndEncode = useCallback(async (htmlContent) => {
    if (!htmlContent) return '';

    // Sanitize HTML
    const sanitizedHtml = DOMPurify.sanitize(htmlContent, { USE_PROFILES: { html: true } });

    // Encode HTML to Base64
    try {
      const base64Html = await encodeHtmlToBase64(sanitizedHtml);
      setEncodedHtml(base64Html);
      // console.log('useSanitizeAndEncode', encodedHtml, 'base64Html', base64Html)
      return base64Html;
    } catch (e) {
      console.error('Error encoding HTML:', e);
      return '';
    }
  }, []);

  return [encodedHtml, sanitizeAndEncode];
};
